__turbopack_context__.v({
  "badge": "car-specs-module__oHhetW__badge",
  "badgeImg": "car-specs-module__oHhetW__badgeImg",
  "badgeMore": "car-specs-module__oHhetW__badgeMore",
  "badgeText": "car-specs-module__oHhetW__badgeText",
  "badges": "car-specs-module__oHhetW__badges",
  "badgesLg": "car-specs-module__oHhetW__badgesLg",
  "grid": "car-specs-module__oHhetW__grid",
  "gridLg": "car-specs-module__oHhetW__gridLg",
  "tile": "car-specs-module__oHhetW__tile",
  "tileCaption": "car-specs-module__oHhetW__tileCaption",
  "tileIcon": "car-specs-module__oHhetW__tileIcon",
  "tileLabel": "car-specs-module__oHhetW__tileLabel",
  "tileText": "car-specs-module__oHhetW__tileText",
  "tip": "car-specs-module__oHhetW__tip",
});
